module.exports = __webpack_public_path__ + "img/8_no.b4f3af8e.svg";